module.exports = __webpack_public_path__ + "img/github.544edda7.svg";